<template>
  <div class="container-fluid">
    <business-profile-cdc-module
        v-if="ready"
        :person="person" />
  </div>
</template>

<script>
import BusinessProfileCdcModule from "./BusinessProfileCdcModule";

export default {
  name: "BusinessProfile",
  components: {BusinessProfileCdcModule},
  data: () => ({
    ready: false,
    rfc: '',
    person: null
  }),
  async mounted() {
    let businessProfileId = this.$route.params.id;

    try {
      const {data} = await axios.get(`/api/business-profile/${businessProfileId}`)
      this.person = data;
      this.rfc = data.rfc;
    } catch (e) {
      // show error
    } finally {
      this.ready = true;
    }

  }
}
</script>

<style scoped>

</style>
